module.exports = __webpack_public_path__ + "img/complex_dashboard.0eab01fa.svg";